import authRequest from 'utils/authRequest'
import studentRequest from 'utils/studentRequest'
import instituteRequest from 'utils/instituteRequest'
import corporateRequest from 'utils/corporateRequest'
import adminRequest from 'utils/adminRequest'
import localRequest from 'utils/localRequest'
import authRequested from 'utils/authRequested'
import { installSessionRefresh } from 'utils/sessionRefresh'
import { SignInSuccess } from 'modules/Auth/actions'

const initApiServices = store => {
  try {
    installSessionRefresh({
      umsRequest: authRequest,
      instances: [
        authRequest,
        studentRequest,
        instituteRequest,
        corporateRequest,
        adminRequest,
        localRequest,
        authRequested,
      ],
      onToken: token => store.dispatch(SignInSuccess(token)),
    })
    authRequest.interceptors.response.use(
      response => {
        return response
      },
      error => {
        if (error?.response?.statusText === 'Unauthorized') {
          localStorage.clear()
          location.reload()
          return new Promise(() => {})
        } else {
          return Promise.reject(new Error(error))
        }
      }
    )
  } catch (e) {
    console.error('Error occurred while logout : in InitApiService', e)
  }
}

export default initApiServices
